/* eslint-disable new-cap */
/* eslint-disable no-plusplus */
import jsPDF from 'jspdf';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { SemanticToastContainer } from 'react-semantic-toasts';
import { translate } from 'react-translate';
import YoutubeModal from 'react-youtube-modal';
import { Button, Container, Dropdown, Form, Grid, Header, Icon, Image, Label, List, Modal, Segment, Table } from 'semantic-ui-react';
import Pdf from '../../../assets/img/pdf.png';
import envList, { getFirstPage } from '../../../constants/envList';
import ProductType from '../../../constants/ProductType';
import API from '../../../services/Api';
import PDFService, { PageType, savedCanvas } from '../../../services/PDFService';
import RtPlusService from '../../../services/rtPlusService';
import StandardService from '../../../services/StandardService';
import UserService from '../../../services/userService';
import ComponentTable from '../../shared/ComponentTable';
import ComponentTableIME from '../../shared/ComponentTableIME';
import HeaderComponent from '../../shared/HeaderComponent';
import TechnicalInfoIcon from '../../shared/TechnicalInfoIcon';
import JobList from '../projet/jobList';
import productInfos from '../projet/productInfos';
import { prepareState } from './index';
import './RtPlusSoluceComponent.css';

const kitFit032 = 'https://www.knaufinsulation.fr/produits/ki-fit-032';
const rtPlus32 = 'https://www.knaufinsulation.fr/produits/rt-plus-032';
const suspentes = 'https://www.knaufinsulation.fr/produits/suspentes-rt-plus';
const manchonRtplusPdf = 'https://www.knaufinsulation.fr/produits/manchons-rt-plus';
const adhesifRtplusPdf = 'https://www.knaufinsulation.fr/produits/adhesifs-rt-plus-et-rt-plus-xl';
let masticRtplusPdfPath = '';
const masticRtPdf = 'https://www.knaufinsulation.fr/produits/mastic-rt';

class rtPlusSoluceComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      openModal: false,
      submitingPdf: false,
      openAdherentXL: false,
      size: window.innerWidth,
    };

    this.onChangeMembrane = this.onChangeMembrane.bind(this);

    this.state.entreChevronsPrice = 0;
    this.state.sousChevronsPriceRtplus = 0;
    this.state.suspentesPriceRtplus = 0;
    this.state.manchonRtplusPrice = 0;
    this.state.adhesifPriceRtplus = 0;
    this.state.adhesifXlPriceRtplus = 0;
    this.state.masticrtplusPrice = 0;

    if (props.location && props.location.state) {
      this.state = props.location.state;
    }

    const { isoValue } = this.state;

    // Initial State
    this.state.suspentesRtplus = isoValue * 2.5;
    this.state.suspentesQuantityRtplus = (isoValue * 2.5) / 50;
    this.state.manchonRtplus = isoValue * 2.5;
    this.state.manchonRtplusQuantity = (isoValue * 2.5) / 50;
    this.state.adhesifRTplusSolution = isoValue * 1.6;
    this.state.adhesifRTPlusQuantitySolution = (isoValue * 1.6) / 40;
    this.state.adhesifXLRTplus = isoValue * 0.4;
    this.state.adhesifXLRTPlusQuantity = Math.ceil(
      (isoValue * 0.4) / 25
    );
    this.state.masticRTRtplus = isoValue * 0.5;
    this.state.masticrtplusQuantity = Math.ceil(
      (isoValue * 0.5) / 12
    );

    // Input changes

    this.changeEntreChevronsRtplus = this.changeEntreChevronsRtplus.bind(this);
    this.changeEntreChevronsPriceRtplus = this.changeEntreChevronsPriceRtplus.bind(
      this
    );
    this.changeSousChevronsRtplus = this.changeSousChevronsRtplus.bind(this);
    this.changeSousChevronsPriceRtplus = this.changeSousChevronsPriceRtplus.bind(
      this
    );
    this.changeSuspentesPriceRtplus = this.changeSuspentesPriceRtplus.bind(
      this
    );
    this.changeManchonRtplusPrice = this.changeManchonRtplusPrice.bind(this);
    this.changeAdhesifXLPriceRtplus = this.changeAdhesifXLPriceRtplus.bind(
      this
    );
    this.changeMasticrtplusPrice = this.changeMasticrtplusPrice.bind(this);

    // Calculation

    this.calculateEntreChevronsRtplus = this.calculateEntreChevronsRtplus.bind(
      this
    );
    this.calculateSousChevronsRtplus = this.calculateSousChevronsRtplus.bind(
      this
    );
    this.calculateSuspentesRtplus = this.calculateSuspentesRtplus.bind(this);
    this.calculateManchonRtplus = this.calculateManchonRtplus.bind(this);
    this.calculateAdhesifXlRtplus = this.calculateAdhesifXlRtplus.bind(this);
    this.calculateMasticrtplus = this.calculateMasticrtplus.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);

    this.changeSuspentesOptionsRtplus = this.changeSuspentesOptionsRtplus.bind(
      this
    );
  }

  componentDidMount() {
    const { match: { params: { env } } } = this.props;
    const { epaisseurChevron, resValue, showMonocouche, isoValue } = this.state;
    if (
      ((epaisseurChevron === 60
        && resValue === 10
        && showMonocouche === false)
      || (resValue === 10 && showMonocouche === true))
      && !envList.isCP
    ) {
      this.setState({ modalOpen: true });
    } else if (
      resValue >= 9
      && showMonocouche === false
      && epaisseurChevron === 60
      && !envList.isCP
    ) {
      this.setState({ modalRtPlusMonocoucheOpen60: true });
    } else if (
      resValue >= 9.5
      && showMonocouche === false
      && epaisseurChevron === 80
      && !envList.isCP
    ) {
      this.setState({ modalRtPlusMonocoucheOpen80: true });
    } else if (resValue >= 7 && showMonocouche === true && !envList.isCP) {
      this.setState({ modalRtPlusMonocoucheOpen: true });
    } else if (envList.isCA(env) || env === envList.CP.path) {
      Promise.all([
        API.getPreselect(resValue, showMonocouche, epaisseurChevron),
        API.getProducts(),
      ]).then(([{ data: { preselect } }, res]) => {
        // Filtres ci dessous
        // Filter for RTplus sous chevrons
        res.data.products.forEach((product) => {
          if (product.name === 'MASTIC RT') masticRtplusPdfPath = product.link;
        });

        const futurState = prepareState(res, preselect, isoValue, env, resValue);

        this.setState(
          {
            ...futurState,
          }, () => {
            this.calculateRtPlusTotal();
            this.calculateResRtplus();
          }
        );
      });

      window.scrollTo(0, 0);
    }
    window.addEventListener('resize', this.resize.bind(this));
  }

  resize = () => this.setState({ size: window.innerWidth });

  handleOpen = () => this.setState({ modalRtPlusMonocoucheOpen: true });

  handleClose = () => this.setState({ modalRtPlusMonocoucheOpen: false });

  handleOpen60 = () => this.setState({ modalRtPlusMonocoucheOpen60: true });

  handleClose60 = () => this.setState({ modalRtPlusMonocoucheOpen60: false });

  handleOpen80 = () => this.setState({ modalRtPlusMonocoucheOpen80: true });

  handleClose80 = () => this.setState({ modalRtPlusMonocoucheOpen80: false });

  handleOpenConfig = () => this.setState({ modalOpen: true });

  handleCloseConfig = () => this.setState({ modalOpen: false });

  handleOpenmodalBlockPdf = () => this.setState({ modalBlockPdfOpen: true });

  handleClosemodalBlockPdf = () => this.setState({ modalBlockPdfOpen: false });

  screenPage() {
    PDFService.screenPage(PageType.RT_PLUS).then(() => {
      this.sendPDF();
    });
  }

  clickDownloadRtplusPdf(urlToOpen) {
    const windowRef = window.open(urlToOpen, '_blank');
    windowRef.focus();
  }

  checkConformityRtplus() {
    const {
      entreChevronsItem,
      sousChevronsItem,
      resValue,
      thermalValueRtplus,
      showMonocouche,
    } = this.state;

    const { match: { params: { env } } } = this.props;

    const conformityRtplus = (
      (
        (
          entreChevronsItem
          && (entreChevronsItem.cpt === 'OUI' || entreChevronsItem.cpt === '1')
        )
        || showMonocouche
      )
      && sousChevronsItem
      && (sousChevronsItem.cpt === 'OUI' || sousChevronsItem.cpt === '1')
    )
    || env === envList.CP.path; // && suspentesPriceRtplus === "OUI"

    const isEnough = resValue <= thermalValueRtplus;

    this.setState({ conformityRtplus, isEnough });
  }

  changeAdhesifRtplus = (_, val) => {
    const adhesif = val.value;

    this.setState({
      selectedAdhesif: adhesif,
    }, () => {
      this.calculateAdhesifRtplus();
    });
  }

  changeSuspentesOptionsRtplus() {
    const {
      arrayEntreChevrons,
    } = this.state;

    const tab1 = arrayEntreChevrons || [];
    const tab2 = arrayEntreChevrons || [];
    let tabSuspentes = tab1.concat(tab2 || []);
    const idPositions = tabSuspentes.map(el => el.key);
    const newPayload = tabSuspentes.filter((item, pos) => idPositions.indexOf(item.key) === pos);
    tabSuspentes = newPayload;
    if (tabSuspentes.length > 0) {
      const suspentesItemRtplus = tabSuspentes[0].value;
      const suspentesPriceRtplus = suspentesItemRtplus.price;
      this.setState(
        {
          suspentesItemRtplus,
          suspentesPriceRtplus,
        },
        () => this.calculateSuspentesRtplus()
      );
    }
    this.setState({
      tabSuspentes,
    });
  }

  changeEntreChevronsRtplus(_, val) {
    const {
      suspentesOptionsRtplus,
    } = this.state;
    const entreChevronsItemRtplus = val.value;
    const tabSuspentesEntre = [];
    API.getRelProduct(entreChevronsItemRtplus.id).then((res) => {
      const entreChevronsRel = res.data.relproductsproducts;
      entreChevronsRel.forEach((rel) => {
        if (rel.products_id_master === entreChevronsItemRtplus.id) {
          let found = false;
          let i = 0;
          while (i < suspentesOptionsRtplus.length && !found) {
            if (
              suspentesOptionsRtplus[i].key
              === rel.products_id_remote
            ) {
              found = true;
              tabSuspentesEntre.push(suspentesOptionsRtplus[i]);
            }
            i++;
          }
        }
      });
      const arrayEntreChevrons = tabSuspentesEntre.filter(
        x => x.value.workstype.indexOf('3') > -1
      );
      this.setState(
        {
          arrayEntreChevrons,
        },
        () => this.changeSuspentesOptionsRtplus()
      );
    });
    const entreChevronsPriceRtplus = entreChevronsItemRtplus.price;
    this.setState(
      {
        entreChevronsItemRtplus,
        entreChevronsPriceRtplus,
      },
      () => {
        this.calculateEntreChevronsRtplus();
        this.calculateResRtplus();
      }
    );
  }

  changeSousChevronsRtplus(_, val) {
    const {
      suspentesOptionsRtplus,
    } = this.state;
    const sousChevronsItemRtplus = val.value;
    const tabSuspentesSous = [];
    API.getRelProduct(sousChevronsItemRtplus.id).then((res) => {
      const sousChevronsRel = res.data.relproductsproducts;
      sousChevronsRel.forEach((element) => {
        if (element.products_id_master === sousChevronsItemRtplus.id) {
          let found = false;
          let i = 0;
          while (i < suspentesOptionsRtplus.length && !found) {
            if (
              suspentesOptionsRtplus[i].key
              === element.products_id_remote
            ) {
              found = true;
              tabSuspentesSous.push(suspentesOptionsRtplus[i]);
            }
            i++;
          }
        }
      });
      const arraySousChevrons = tabSuspentesSous.filter(
        x => x.value.workstype.indexOf('3') > -1
      );
      this.setState(
        {
          arraySousChevrons,
        },
        () => {
          this.changeSuspentesOptionsRtplus();
        }
      );
    });
    const sousChevronsPriceRtplus = sousChevronsItemRtplus.price;
    this.setState(
      {
        sousChevronsItemRtplus,
        sousChevronsPriceRtplus,
      },
      () => {
        this.calculateSousChevronsRtplus();
        this.calculateResRtplus();
      }
    );
  }

  changeSuspentesRtplus(_, val) {
    const suspentesItemRtplus = val.value;
    const suspentesPriceRtplus = suspentesItemRtplus && suspentesItemRtplus.price;
    this.setState(
      {
        suspentesItemRtplus,
        suspentesPriceRtplus,
      },
      () => this.calculateSuspentesRtplus()
    );
  }

  changeEntreChevronsPriceRtplus(_, val, noFormat) {
    const { entreChevronsOptions, entreChevronsItem } = this.state;

    this.setState({
      entreChevronsItem: {
        ...entreChevronsItem,
        price: val.value,
        noFormat,
      },
    });
    for (let i = 0; i < entreChevronsOptions.length; i++) {
      if (entreChevronsOptions[i].text === entreChevronsItem.name) {
        entreChevronsOptions[i].value.price = val.value;
        entreChevronsOptions[i].value.noFormat = noFormat;
      }
    }
    this.setState({ entreChevronsOptions }, () => {
      this.calculateEntreChevronsRtplus();
    });
  }

  changeSousChevronsPriceRtplus(_, val, noFormat) {
    const { sousChevronsOptions, sousChevronsItem } = this.state;

    this.setState({
      sousChevronsItem: {
        ...sousChevronsItem,
        price: val.value,
        noFormat,
      },
    });

    for (let i = 0; i < sousChevronsOptions.length; i++) {
      if (sousChevronsOptions[i].text === sousChevronsItem.name) {
        sousChevronsOptions[i].value.price = val.value;
        sousChevronsOptions[i].value.noFormat = noFormat;
      }
    }

    this.setState({ sousChevronsOptions }, () => {
      this.calculateSousChevronsRtplus();
    });
  }

  changeSuspentesPriceRtplus(_, val, noFormat) {
    const { suspentesOptionsRtplus, suspentesItem } = this.state;

    for (let i = 0; i < suspentesOptionsRtplus.length; i++) {
      if (suspentesOptionsRtplus[i].text === suspentesItem.name) {
        suspentesOptionsRtplus[i].value.price = val.value;
        suspentesOptionsRtplus[i].value.noFormat = noFormat;
      }
    }

    this.setState(
      {
        suspentesOptionsRtplus,
        suspentesItem: {
          ...suspentesItem,
          price: val.value,
          noFormat,
        },
      },
      () => {
        this.calculateSuspentesRtplus();
      });
  }

  changeManchonRtplusPrice(_, val, noFormat) {
    const manchonRtplusPrice = val.value;
    this.setState(
      {
        manchonRtplusPrice,
        mamanchonNoFormat: noFormat,
      },
      () => this.calculateManchonRtplus()
    );
  }

  changeAdhesifRtplusPrice(_, val, noFormat) {
    const { selectedAdhesif } = this.state;
    if (selectedAdhesif) {
      selectedAdhesif.price = val.value;
      selectedAdhesif.noFormat = noFormat;

      this.setState({ adhesifPriceRtplus: val.value, selectedAdhesif }, () => {
        this.calculateAdhesifRtplus();
      });
    }
  }

  changeAdhesifXLPriceRtplus(_, val) {
    const adhesifXlPriceRtplus = val.value;
    this.setState(
      {
        adhesifXlPriceRtplus,
      },
      () => this.calculateAdhesifXlRtplus()
    );
  }

  changeMasticrtplusPrice(_, val, noFormat) {
    const masticrtplusPrice = val.value;

    this.setState(
      {
        masticrtplusPrice,
        masticNoFormat: noFormat,
        masticPrice: val.value,
      },
      () => { this.calculateMasticrtplus(); }
    );
  }

  calculateEntreChevronsRtplus() {
    const { entreChevronsItem, isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.BETWEEN_CHEVRON,
        productData: entreChevronsItem,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      surface: costs.betweenChevron.surface,
      nbRouleau: costs.betweenChevron.nbRouleau,
      tarifPerSurface: costs.betweenChevron.tarifPerSurface,
    }, () => {
      this.checkConformityRtplus();
      this.calculateRtPlusTotal();
    });
  }

  calculateSousChevronsRtplus() {
    const { sousChevronsItem, isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.UNDER_CHEVRON,
        productData: sousChevronsItem,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      surfaceSousChevrons: costs.underChevron.surfaceSousChevrons,
      nbreRouleau: costs.underChevron.nbreRouleau,
      tarifOnSurface: costs.underChevron.tarifOnSurface,
    }, () => {
      this.checkConformityRtplus();
      this.calculateRtPlusTotal();
    });
  }

  calculateSuspentesRtplus() {
    const { suspentesItem, isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.SHROUD,
        productData: suspentesItem,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifDeSurface: costs.shroud.tarifDeSurface,
    }, () => {
      this.checkConformityRtplus();
      this.calculateRtPlusTotal();
    });
  }

  calculateManchonRtplus() {
    const {
      manchonRtplusQuantity,
    } = this.state;

    const tarifSurfaceManchon = manchonRtplusQuantity * manchonRtplusQuantity;
    this.setState(
      {
        tarifSurfaceManchon,
      },
      () => this.calculateRtPlusTotal()
    );
  }

  calculateAdhesifRtplus() {
    const { isoValue, selectedAdhesif } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.ADHESIVE,
        productData: selectedAdhesif,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      ...costs.adhesive,
    }, () => {
      this.checkConformityRtplus();
      this.calculateRtPlusTotal();
    });
  }

  calculateAdhesifXlRtplus() {
    const {
      adhesifRTPlusQuantitySolution,
      adhesifPriceRtplus,
    } = this.state;
    const tarifAdhesif = adhesifRTPlusQuantitySolution * adhesifPriceRtplus;
    const { isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.ADHESIVE,
        productData: {
          quantity: (isoValue * 2.0) / 40,
          price: tarifAdhesif,
        },
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifAdhesif: costs.adhesive.tarifAdhesif,
    }, () => {
      this.checkConformityRtplus();
      this.calculateRtPlusTotal();
    });
  }

  calculateMasticrtplus() {
    const { isoValue, masticrtplusPrice } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.MASTIC,
        productData: {
          quantity: Math.ceil((isoValue * 0.5) / 12),
          price: masticrtplusPrice,
        },
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifMasticRt: costs.mastic.tarifMasticRt,
    }, () => {
      this.checkConformityRtplus();
      this.calculateRtPlusTotal();
    });
  }

  calculateResRtplus() {
    const {
      entreChevronsItem,
      sousChevronsItem,
      showMonocouche,
    } = this.state;

    const entreChevronsResRtplus = (
      entreChevronsItem || { resistance: 0 }
    ).resistance;
    const sousChevronsResRtplus = (
      sousChevronsItem || { resistance: 0 }
    ).resistance;

    const thermalValueRtplus = (
      ((!showMonocouche && Number(entreChevronsResRtplus)) || 0) + Number(sousChevronsResRtplus)
    ).toFixed(2);

    this.setState({
      thermalValueRtplus,
    }, () => {
      this.checkConformityRtplus();
    });
  }

  getJob = () => {
    const tmp = UserService.getTokenCleared();
    if (tmp) {
      return tmp.job;
    }

    return JobList.USER;
  };

  dataURItoBlob = (dataURI) => {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    const ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    const blob = new Blob([ab], { type: mimeString });
    return blob;
  };

  async sendPDF() {
    const { match: { params: { env } } } = this.props;

    const landing = savedCanvas[PageType.LANDING]();
    const compare = savedCanvas[PageType.COMPARE]();
    const standard = savedCanvas[PageType.STANDARD]();
    const rtMax = savedCanvas[PageType.RT_MAX]();
    const rtPlus = savedCanvas[PageType.RT_PLUS]();

    if (!standard || (env !== envList.CP.path && !rtMax) || !rtPlus) {
      this.handleOpenmodalBlockPdf();
      return;
    }

    const getSizeImage = value => new Promise((resolve) => {
      const image = document.createElement('img');
      image.addEventListener('load', () => {
        const x = 0;
        const y = 2;
        const a = 'PNG';
        const f = '';
        const g = 'FAST';
        resolve({ x, y, a, f, g });
      });
      image.src = value;
    }, 2000);

    const config1 = await getSizeImage(landing);
    const config2 = await getSizeImage(compare);
    const config3 = await getSizeImage(standard);
    const config4 = rtMax ? await getSizeImage(rtMax) : undefined;
    const config5 = await getSizeImage(rtPlus);

    this.setState(
      prevState => ({
        ...prevState,
        submitingPdf: true,
      }),
      async () => {
        await new Promise(resolve => setTimeout(resolve, 1000));
        const pdf = new jsPDF({
          unit: 'px',
          format: 'a4',
        });

        pdf.addImage(
          landing,
          config1.a,
          config1.x,
          config1.y,
          pdf.internal.pageSize.getWidth(),
          pdf.internal.pageSize.getHeight(),
          config1.f,
          config1.g,
        );
        pdf.addPage();
        pdf.addImage(
          compare,
          config2.a,
          config2.x,
          config2.y,
          pdf.internal.pageSize.getWidth(),
          pdf.internal.pageSize.getHeight(),
          config2.f,
          config2.g,
        );
        pdf.addPage();
        pdf.addImage(
          standard,
          config3.a,
          config3.x,
          config3.y,
          pdf.internal.pageSize.getWidth(),
          pdf.internal.pageSize.getHeight(),
          config3.f,
          config3.g,
        );
        if (rtMax) {
          pdf.addPage();
          pdf.addImage(
            rtMax,
            config4.a,
            config4.x,
            config4.y,
            pdf.internal.pageSize.getWidth(),
            pdf.internal.pageSize.getHeight(),
            config4.f,
            config4.g,
          );
        }
        pdf.addPage();
        pdf.addImage(
          rtPlus,
          config5.a,
          config5.x,
          config5.y,
          pdf.internal.pageSize.getWidth(),
          pdf.internal.pageSize.getHeight(),
          config5.f,
          config5.g,
        );
        pdf.save('export.pdf');
        this.setState({
          submitingPdf: false,
          loading: false,
        });
      }
    );
  }

  handleChangeEmail(evt, val) {
    const email = val.value;
    this.setState({
      email,
    });
  }

  calculateRtPlusTotal() {
    const { match: { params: { env } } } = this.props;

    let rtPlusTotal = 0;

    if (env === envList.CP.path) {
      const {
        costInsBlown,
        tarifDeSurface,
        adhesifCost,
        costMem,
        masticCost,
      } = this.state;

      rtPlusTotal = Number(
        costInsBlown
        + tarifDeSurface
        + adhesifCost
        + costMem
        + masticCost
      ).toFixed(1);
    } else {
      const {
        adhesifCost,
        showMonocouche,
        tarifDeSurface,
        tarifMasticRt,
        tarifOnSurface,
        tarifPerSurface,
        tarifSurfaceManchon,
      } = this.state;

      const totalEntreChevronsRtplus = showMonocouche
        ? 0
        : Number(tarifPerSurface) || 0;
      const totalSousChevronsRtplus = Number(tarifOnSurface) || 0;
      const totalSuspentesRtplus = Number(tarifDeSurface) || 0;
      const totalManchonRtplus = Number(tarifSurfaceManchon) || 0;
      const totalAdhesifRtplus = Number(adhesifCost) || 0;
      const totalMasticRt = Number(tarifMasticRt) || 0;

      rtPlusTotal = Number(
        (showMonocouche ? 0 : totalEntreChevronsRtplus)
        + totalSousChevronsRtplus
        + totalSuspentesRtplus
        + totalManchonRtplus
        + totalAdhesifRtplus
        + totalMasticRt
      ).toFixed(1);
    }

    this.setState({
      rtPlusTotal,
    });
  }

  advantagesrender() {
    const { match: { params: { env } }, t } = this.props;

    const jobId = this.getJob();

    const advantages = productInfos[env].formula.rtPlus.advantageKey[jobId].map(advantageId => (
      <li className="listItemBenefitRtplus">
        {t(advantageId)}
      </li>
    ));

    return (
      <ul className="listBenefitRtplus">
        {advantages}
      </ul>
    );
  }

  inconvenienceRender() {
    const { match: { params: { env } }, t } = this.props;

    const jobId = this.getJob();

    const inconvenience = productInfos[env]
      .formula.rtPlus
      .inconvenienceKey[jobId]
      .map(inconvenienceId => (
        <li className="listItemBenefitRtplus">
          {t(inconvenienceId)}
        </li>
      ));

    return (
      <ul className="listBenefitRtplus">
        {inconvenience}
      </ul>
    );
  }

  onChangeMembrane(_, inputData) {
    const { match: { params: { env } } } = this.props;
    const { isoValue } = this.state;

    const { value: selected } = inputData;

    const costs = RtPlusService.calculateCost([
      {
        type: ProductType.MEMBRANE,
        productData: selected,
      },
    ], isoValue, env);

    this.setState({
      selectedMembrane: selected,
      ...costs.membrane,
    }, () => {
      this.calculateRtPlusTotal();
      this.checkConformityRtplus();
    });
  }

  componentRender() {
    const { match: { params: { env } }, t } = this.props;
    const { showMonocouche } = this.state;
    const { components } = productInfos[env].formula.rtPlus;
    const toRender = [];
    let firstVisibleAdded = false;

    for (let i = 0; i < components.length; i++) {
      const component = components[i];

      toRender.push(
        <List.Item
          className={firstVisibleAdded ? 'listItemSoluce' : 'listrtPlus'}
          style={
            !component.alwaysShow && showMonocouche
              ? { display: 'none' }
              : { display: 'block' }
          }
        >
          {t(component.key)}
        </List.Item>
      );

      if (component.alwaysShow || (!component.alwaysShow && !showMonocouche)) {
        firstVisibleAdded = true;
      }
    }

    return toRender;
  }

  renderComponentTable() {
    const { match, match: { params: { env } }, t } = this.props;
    const {
      resValue,
      isoValue,
      selectedInsulator,
      selectedSuspentes,
      selectedAdhesive,
      selectedMembrane,
      selectedMastic,
      tarifDeSurface,
      nbBox,
      qteUsed,
      adhesifBox,
      usedAdhesif,
      adhesifCost,
      usedMem,
      nbRollMem,
      costMem,
      masticBox,
      usedMastic,
      masticCost,
      adhesives,
      insulators,
      mastics,
      membranes,
      suspentes: shroud,
      costInsBlown,
      usedInsBlown,
      nbRollInsBlown,
    } = this.state;

    switch (env) {
      case envList.CA.path: {
        const {
          entreChevronsItem,
          entreChevronsOptions,
          mamanchonNoFormat,
          manchonRtplus,
          manchonRtplusPrice,
          manchonRtplusQuantity,
          masticNoFormat,
          masticPrice,
          masticrtplusQuantity,
          masticRTRtplus,
          nbreRouleau,
          nbRouleau,
          openAdherentXL,
          selectedAdhesif,
          showMonocouche,
          size,
          sousChevronsItem,
          sousChevronsOptions,
          surface,
          surfaceSousChevrons,
          suspentesOptionsRtplus,
          suspentesQuantityRtplus,
          suspentesRtplus,
          tarifMasticRt,
          tarifOnSurface,
          tarifPerSurface,
          tarifSurfaceManchon,
        } = this.state;

        return (
          <Table basic="very" className="tableRtPlusSoluce">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell />
                <Table.HeaderCell>{t('rtplus_table_title')}</Table.HeaderCell>
                <Table.HeaderCell />
                <Table.HeaderCell>
                  {t('rtplus_table_title_quantity')}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {t('rtplus_table_title_unité')}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {t('rtplus_table_title_surface')}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                  showMonocouche || (
                  <Table.Row>
                    <Table.Cell>1. </Table.Cell>
                    <Table.Cell className="cellTablertPlus">
                      {t('rtplus_table_iso_entre_chevrons')}
                      <TechnicalInfoIcon
                        onClick={
                          () => this.clickDownloadRtplusPdf(
                            entreChevronsItem.link
                            && entreChevronsItem.link.length > 0
                              ? entreChevronsItem.link
                              : kitFit032
                          )
                        }
                      />
                      <br />
                      <Dropdown
                        search
                        selection
                        disabled
                        options={entreChevronsOptions}
                        value={entreChevronsItem}
                        onChange={
                          (e, val) => this.changeEntreChevronsRtplus(e, val)
                        }
                      />
                    </Table.Cell>
                    <Table.Cell className="cellTable">
                      {(surface || 0).toFixed(2)}
                      {t('rtplus_table_iso_entre_chevrons_surface')}
                    </Table.Cell>
                    <Table.Cell className="cellTableQuantity">
                      {(nbRouleau || 0).toFixed(2)}
                      {t('rtplus_table_iso_entre_chevrons_rouleau')}
                    </Table.Cell>
                    <Table.Cell className="cellTablertPlus">
                      <Form className="inputInTable">
                        <Form.Input
                          width={8}
                          step={0.10}
                          type="number"
                          onClick={e => e.target.select()}
                          disabled={UserService.isUser()}
                          value={
                            entreChevronsItem && entreChevronsItem.noFormat
                              ? entreChevronsItem && entreChevronsItem.price
                              : Number(
                                (entreChevronsItem && entreChevronsItem.price) || 0
                              ).toFixed(2)
                          }
                          onChange={(e, val) => this.changeEntreChevronsPriceRtplus(e, val, true)}
                          onBlur={
                            () => {
                              this.changeEntreChevronsPriceRtplus(
                                null,
                                {
                                  value: entreChevronsItem && entreChevronsItem.price,
                                },
                                false
                              );
                            }
                          }
                        />
                        <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                          {t('rtplus_table_iso_entre_chevrons_price')}
                        </Label>
                      </Form>
                    </Table.Cell>
                    <Table.Cell className="cellTable">
                      {(tarifPerSurface || 0).toFixed(2)}
                      {t('rtplus_table_iso_entre_chevrons_tarifsurface')}
                    </Table.Cell>
                  </Table.Row>
                  )
                }
              <Table.Row>
                <Table.Cell>
                  {1 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  {t('rtplus_table_iso_sous_chevrons')}
                  <TechnicalInfoIcon
                    onClick={
                      () => this.clickDownloadRtplusPdf(
                        sousChevronsItem.link && sousChevronsItem.link.length > 0
                          ? sousChevronsItem.link
                          : rtPlus32
                      )
                    }
                  />
                  <br />
                  <Dropdown
                    search
                    selection
                    disabled
                    options={sousChevronsOptions}
                    value={sousChevronsItem}
                    onChange={(e, val) => this.changeSousChevronsRtplus(e, val)
                      }
                  />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(surfaceSousChevrons || 0).toFixed(2)}
                  {t('rtplus_table_iso_sous_chevrons_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(nbreRouleau || 0).toFixed(2)}
                  {t('rtplus_table_iso_sous_chevrons_rouleau')}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  <Form className="inputInTable">
                    <Form.Input
                      width={8}
                      step={0.10}
                      type="number"
                      disabled={UserService.isUser()}
                      onClick={e => e.target.select()}
                      value={
                            sousChevronsItem && sousChevronsItem.noFormat
                              ? sousChevronsItem && sousChevronsItem.price
                              : Number((sousChevronsItem && sousChevronsItem.price) || 0).toFixed(2)
                          }
                      onChange={(e, val) => this.changeSousChevronsPriceRtplus(e, val, true)}
                      onBlur={() => {
                        this.changeSousChevronsPriceRtplus(
                          null,
                          {
                            value: sousChevronsItem && sousChevronsItem.price,
                          },
                          false
                        );
                      }}
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtplus_table_iso_sous_chevrons_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {Number(tarifOnSurface || 0).toFixed(2)}
                  {t('rtplus_table_iso_sous_chevrons_tarifsurface')}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {2 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  {t('rtplus_table_suspentes')}
                  <TechnicalInfoIcon
                    onClick={
                      () => this.clickDownloadRtplusPdf(
                        selectedSuspentes.link && selectedSuspentes.link.length > 0
                          ? selectedSuspentes.link
                          : suspentes
                      )
                    }
                  />
                  <br />
                  <Dropdown
                    search
                    selection
                    disabled
                    options={suspentesOptionsRtplus}
                    value={selectedSuspentes}
                    onChange={(e, val) => this.changeSuspentesRtplus(e, val)}
                  />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(suspentesRtplus || 0).toFixed(2)}
                  {t('rtplus_table_suspentes_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(suspentesQuantityRtplus || 0).toFixed(2)}
                  {t('rtplus_table_suspentes_boites')}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  <Form className="inputInTable">
                    <Form.Input
                      width={8}
                      step={0.10}
                      type="number"
                      disabled={UserService.isUser()}
                      onClick={e => e.target.select()}
                      value={
                        selectedSuspentes && selectedSuspentes.noFormat
                          ? selectedSuspentes && selectedSuspentes.price
                          : Number((selectedSuspentes && selectedSuspentes.price) || 0).toFixed(2)
                      }
                      onChange={(e, val) => this.changeSuspentesPriceRtplus(e, val, true)}
                      onBlur={
                        () => {
                          this.changeSuspentesPriceRtplus(
                            null,
                            {
                              value: selectedSuspentes && selectedSuspentes.price,
                            },
                            false
                          );
                        }
                      }
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtplus_table_suspentes_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {Number(tarifDeSurface || 0).toFixed(2)}
                  {t('rtplus_table_suspentes_tarifsurface')}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {3 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  {t('rtplus_table_manchon')}
                  <TechnicalInfoIcon
                    onClick={() => this.clickDownloadRtplusPdf(manchonRtplusPdf)
                      }
                  />
                  <br />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(manchonRtplus || 0).toFixed(2)}
                  {t('rtplus_table_manchon_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(manchonRtplusQuantity || 0).toFixed(2)}
                  {t('rtplus_table_manchon_boite')}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  <Form className="inputInTable">
                    <Form.Input
                      width={8}
                      step={0.10}
                      type="number"
                      onClick={e => e.target.select()}
                      disabled={UserService.isUser()}
                      value={
                            mamanchonNoFormat
                              ? manchonRtplusPrice
                              : Number(manchonRtplusPrice).toFixed(2)
                          }
                      onChange={(e, val) => this.changeManchonRtplusPrice(e, val, true)}
                      onBlur={() => {
                        this.changeManchonRtplusPrice(null, { value: manchonRtplusPrice }, false);
                      }}
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtplus_table_manchon_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {Number(tarifSurfaceManchon || 0).toFixed(2)}
                  {t('rtplus_table_manchon_tarifsurface')}
                </Table.Cell>
              </Table.Row>
              <Table.Row style={!openAdherentXL ? { display: 'table-row' } : { display: 'none' }}>
                <Table.Cell>
                  {4 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  {t('rtplus_table_adhesif')}
                  <TechnicalInfoIcon
                    onClick={() => this.clickDownloadRtplusPdf(adhesifRtplusPdf)
                      }
                  />
                  <br />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(usedAdhesif || 0).toFixed(2)}
                  {t('rtplus_table_adhesif_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(adhesifBox || 0).toFixed(2)}
                  {t('rtplus_table_adhesif_rouleau')}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  <Form className="inputInTable">
                    <Form.Input
                      width={8}
                      step={0.10}
                      type="number"
                      onClick={e => e.target.select()}
                      disabled={UserService.isUser()}
                      value={
                            selectedAdhesif && selectedAdhesif.noFormat
                              ? selectedAdhesif && selectedAdhesif.price
                              : Number((selectedAdhesif && selectedAdhesif.price) || 0).toFixed(2)
                          }
                      onChange={(e, val) => this.changeAdhesifRtplusPrice(e, val, true)}
                      onBlur={
                            () => {
                              this.changeAdhesifRtplusPrice(
                                null,
                                {
                                  value: (selectedAdhesif && selectedAdhesif.price),
                                },
                                false
                              );
                            }
                          }
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtplus_table_adhesif_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(adhesifCost || 0).toFixed(2)}
                  {t('rtplus_table_adhesif_tarifsurface')}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {5 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  {t('rtplus_table_mastic')}
                  <TechnicalInfoIcon
                    onClick={
                      () => this.clickDownloadRtplusPdf(
                        masticRtplusPdfPath > 0
                          ? masticRtplusPdfPath
                          : masticRtPdf
                      )
                    }
                  />
                  <br />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(masticRTRtplus || 0).toFixed(2)}
                  {t('rtplus_table_mastic_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(masticrtplusQuantity || 0).toFixed(2)}
                  {t('rtplus_table_mastic_cartouches')}
                </Table.Cell>
                <Table.Cell className="cellTablertPlus">
                  <Form className="inputInTable">
                    <Form.Input
                      width={8}
                      step={0.10}
                      type="number"
                      onClick={e => e.target.select()}
                      disabled={UserService.isUser()}
                      value={
                            masticNoFormat
                              ? masticPrice
                              : Number(masticPrice).toFixed(2)
                          }
                      onChange={(e, val) => this.changeMasticrtplusPrice(e, val, true)}
                      onBlur={
                        () => { this.changeMasticrtplusPrice(null, { value: masticPrice }, false); }
                      }
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtplus_table_mastic_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {Number(tarifMasticRt || 0).toFixed(2)}
                  {t('rtplus_table_mastic_tarifsurface')}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        );
      }
      case envList.IME.path: {
        return (
          <ComponentTableIME
            worktype="3"
            resValue={resValue}
            isoValue={isoValue}
            onThermalChange={(newThermalValueRtplus) => {
              this.setState({ thermalValueRtplus: newThermalValueRtplus });
            }}
            onTotalChange={(total) => {
              this.setState({ rtPlusTotal: total });
            }}
            onIsEnoughChange={(enought) => {
              this.setState({ isEnough: enought });
            }}
            onConformitychange={(newConformityRtplus) => {
              this.setState({ conformityRtplus: newConformityRtplus });
            }}
          />
        );
      }
      case envList.CP.path: {
        const componentsData = [
          {
            selectedInsulator,
            costInsBlown,
            usedInsBlown,
            nbRollInsBlown,
            insulators,
            onChange: (val) => {
              this.setState({
                selectedInsulator: {
                  ...selectedInsulator,
                  price: val,
                  noFormat: true,
                },
              });
            },
            onBlur: () => {
              const { insulatorBlown } = RtPlusService.calculateCost(
                [
                  {
                    type: ProductType.INSULATOR_BLOWN,
                    productData: selectedInsulator,
                  },
                ],
                isoValue,
                env,
              );
              this.setState({
                costInsBlown: insulatorBlown.costInsBlown,
                selectedInsulator: {
                  ...selectedInsulator,
                  noFormat: false,
                },
              });
            },
          },
          {
            selectedSuspentes,
            tarifDeSurface,
            nbBox,
            qteUsed,
            shroud,
            onChange: (val) => {
              this.setState({
                selectedSuspentes: {
                  ...selectedSuspentes,
                  price: val,
                  noFormat: true,
                },
              });
            },
            onBlur: () => {
              const { shroud: shroudCost } = RtPlusService.calculateCost(
                [
                  {
                    type: ProductType.SHROUD,
                    productData: selectedSuspentes,
                  },
                ],
                isoValue,
                env,
              );
              this.setState({
                tarifDeSurface: shroudCost.tarifDeSurface,
                selectedSuspentes: {
                  ...selectedSuspentes,
                  noFormat: false,
                },
              });
            },
          },
          {
            selectedAdhesive,
            adhesifBox,
            usedAdhesif,
            adhesifCost,
            adhesives,
            onChange: (val) => {
              this.setState({
                selectedAdhesive: {
                  ...selectedAdhesive,
                  price: val,
                  noFormat: true,
                },
              });
            },
            onBlur: () => {
              const { adhesive } = RtPlusService.calculateCost(
                [
                  {
                    type: ProductType.ADHESIVE,
                    productData: selectedAdhesive,
                  },
                ],
                isoValue,
                env,
              );
              this.setState({
                adhesifCost: adhesive.adhesifCost,
                selectedAdhesive: {
                  ...selectedAdhesive,
                  noFormat: false,
                },
              });
            },
          },
          {
            selectedMembrane,
            usedMem,
            nbRollMem,
            costMem,
            membranes,
            onChangeList: this.onChangeMembrane,
            onChange: (val) => {
              this.setState({
                selectedMembrane: {
                  ...selectedMembrane,
                  price: val,
                  noFormat: true,
                },
              });
            },
            onBlur: () => {
              const { membrane } = RtPlusService.calculateCost(
                [
                  {
                    type: ProductType.MEMBRANE,
                    productData: selectedMembrane,
                  },
                ],
                isoValue,
                env,
              );
              this.setState({
                costMem: membrane.costMem,
                selectedMembrane: {
                  ...selectedMembrane,
                  noFormat: false,
                },
              });
            },
          },
          {
            selectedMastic,
            masticBox,
            usedMastic,
            masticCost,
            mastics,
            onChange: (val) => {
              this.setState({
                selectedMastic: {
                  ...selectedMastic,
                  price: val,
                  noFormat: true,
                },
              });
            },
            onBlur: () => {
              const { mastic } = RtPlusService.calculateCost(
                [
                  {
                    type: ProductType.MASTIC,
                    productData: selectedMastic,
                  },
                ],
                isoValue,
                env,
              );
              this.setState({
                masticCost: mastic.masticCost,
                selectedMastic: {
                  ...selectedMastic,
                  noFormat: false,
                },
              });
            },
          },
        ];

        return (
          <ComponentTable
            t={t}
            workstype={3}
            match={match}
            components={componentsData}
          />
        );
      }
      default:
        break;
    }
  }

  render() {
    const { t, match: { params: { env } }, history } = this.props;
    const {
      conformityRtplus,
      isEnough,
      resValue,
      showMonocouche,
      thermalValueRtplus,
      rtPlusTotal,
      modalBlockPdfOpen,
    } = this.state;

    const { formula: { rtPlus } } = productInfos[env];

    return (
      <div>
        <Modal
          id="ModalNotAllDataForPDF"
          open={modalBlockPdfOpen}
          onClose={this.handleClosemodalBlockPdf}
        >
          <Header
            icon="times"
            color="red"
            content={t('not_all_data')}
          />
          <Modal.Content>
            <h3>{t('go_see_other_soluctions')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={this.handleClosemodalBlockPdf} inverted>
              <Icon name="checkmark" />
              {' '}
              OK
            </Button>
          </Modal.Actions>
        </Modal>
        <Modal
          id="ModalExportMail"
          open={this.state.modalOpen}
          onClose={this.handleCloseConfig}
        >
          <Header
            icon="times"
            color="red"
            content={t('title_modal_impossible_configuration')}
          />
          <Modal.Content>
            <h3>{t('incompatible_modal_epaisseur_resistance')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Link to={{ pathname: getFirstPage(env) }}>
              <Button color="red" onClick={this.handleCloseConfig} inverted>
                <Icon name="checkmark" />
                {' '}
                OK
              </Button>
            </Link>
          </Modal.Actions>
        </Modal>
        <Modal
          id="ModalExportMail"
          open={this.state.modalRtPlusMonocoucheOpen}
          onClose={this.handleClose}
        >
          <Header icon="times" color="red" content="Aucune solution" />
          <Modal.Content>
            <h3>{t('incompatible_modal_rtplus_resistance')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Link to={getFirstPage(env)}>
              <Button color="red" onClick={this.handleClose} inverted>
                <Icon name="reply" />
                {' '}
                {t('incompatible_modal_ok')}
              </Button>
            </Link>
            <Button color="blue" onClick={() => this.screenPage()} inverted>
              <Icon name="upload" />
              {' '}
              {t('rtplus_button_next')}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal
          id="ModalExportMail"
          open={this.state.modalRtPlusMonocoucheOpen60}
          onClose={this.handleClose60}
        >
          <Header icon="times" color="red" content="Aucune solution" />
          <Modal.Content>
            <h3>{t('incompatible_modal_rtplus_60')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Link to={getFirstPage(env)}>
              <Button color="red" onClick={this.handleClose60} inverted>
                <Icon name="reply" />
                {' '}
                {t('incompatible_modal_ok')}
              </Button>
            </Link>
            <Button color="blue" onClick={() => this.screenPage()} inverted>
              <Icon name="upload" />
              {' '}
              {t('rtplus_button_next')}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal
          id="ModalExportMail"
          open={this.state.modalRtPlusMonocoucheOpen80}
          onClose={this.handleClose80}
        >
          <Header icon="times" color="red" content="Aucune solution" />
          <Modal.Content>
            <h3>{t('incompatible_modal_rtplus_80')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Link to={getFirstPage(env)}>
              <Button color="red" onClick={this.handleClose80} inverted>
                <Icon name="reply" />
                {' '}
                {t('incompatible_modal_ok')}
              </Button>
            </Link>
            <Button color="blue" onClick={() => this.screenPage()} inverted>
              <Icon name="upload" />
              {' '}
              {t('rtplus_button_next')}
            </Button>
          </Modal.Actions>
        </Modal>

        <HeaderComponent
          currentPage={5}
          commonState={this.state}
          history={history}
        />
        <Container id="rtPlusSoluce">
          <Segment>
            <Container as="h2" id="rtPlusTitle">
              {t('rtplus_solution_title')}
            </Container>
            <Grid columns={1}>
              <Grid.Row>
                <Grid.Column width={100}>
                  { rtPlus.displayTuto && (
                  <YoutubeModal videoId={rtPlus.tutoVideoId} height="400px" width="700px">
                    <Button
                      floated="right"
                      id="tutorialButtonrtPlus"
                      size="big"
                      target="_blank"
                    >
                      {t('rtplus_tutorial_button')}
                      <Icon name="wrench" id="iconTuto" />
                    </Button>
                  </YoutubeModal>
                  )}
                  <Segment basic id="rtPlusText">
                    {t(rtPlus.descriptionKey[JobList.PRO])}
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            </Grid>

            <Segment basic>
              <Grid columns="equal" id="tabContainer">
                <Grid.Row>
                  <Grid.Column className="tabCell rtMaxCell">
                    <div className="rowText">
                      <ul className="avantageTitleRtplus">
                        {t('rtplus_advantages_title')}
                      </ul>
                    </div>
                  </Grid.Column>
                  <Grid.Column className="tabCell rtMaxCell">
                    <div className="rowText">
                      <ul className="avantageTitleRtplus">
                        {t('rtplus_disadvantages_title')}
                      </ul>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid columns="equal" id="tabContainer">
                <Grid.Row>
                  <Grid.Column className="tabCell rtMaxCell">
                    <div className="rowText">
                      {this.advantagesrender()}
                    </div>
                  </Grid.Column>
                  <Grid.Column className="tabCell rtMaxCell">
                    <div className="rowText">
                      {this.inconvenienceRender()}
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            <Segment>
              <Grid>
                <Grid.Row>
                  <Grid.Column id="divImagertPlus" computer={8} tablet={16}>
                    <Image
                      src={!showMonocouche ? rtPlus.composantsImg : rtPlus.composantsBicImg}
                      size="big"
                    />
                  </Grid.Column>
                  <Grid.Column computer={8} tablet={16}>
                    <List divided relaxed fluid ordered>
                      <Label as="h2" id="composantTitlertPlus">
                        {t('rtplus_component_list')}
                      </Label>
                      {this.componentRender()}
                    </List>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            <Segment className="segmentPanneau">
              <Grid>
                <Grid.Row id="rtPlusPanneau">
                  <Grid.Column tablet={8} computer={4}>
                    <Segment basic>
                      <div as="h4" className="rtPlusSoluceTitle">
                        {t('rtplus_reswait')}
                      </div>
                      <div className="SoluceNumbers">
                        {resValue}
                        {t('rtplus_res_unit')}
                      </div>
                      <div className="underlinePanneau">
                        ______________________________
                      </div>
                    </Segment>
                  </Grid.Column>
                  <Grid.Column tablet={8} computer={4}>
                    <Segment basic>
                      <div as="h4" className="rtPlusSoluceTitle">
                        {t('rtplus_thermal_res')}
                      </div>
                      <div
                        className={
                          isEnough || env === envList.CP.path
                            ? 'SoluceNumbers'
                            : 'SoluceNumbers Invalid'
                        }
                      >
                        {env === envList.CP.path ? resValue : thermalValueRtplus}
                        {t('rtplus_thermal_res_unit')}
                      </div>
                      <div
                        className={
                          isEnough || env === envList.CP.path
                            ? 'underlinePanneau'
                            : 'underlinePanneau Invalid'
                        }
                      >
                        ______________________________
                      </div>
                    </Segment>
                  </Grid.Column>
                  <Grid.Column tablet={12} computer={8}>
                    { productInfos[env].haveCpt
                      && (
                      <Segment basic>
                        <div as="h4" className="rtPlusSoluceTitle">
                          {
                            env === envList.CP.path
                              ? t('rtplus_conformity_cp')
                              : t('rtplus_conformity')
                          }
                        </div>
                        <div
                          className={
                          conformityRtplus
                            ? 'SoluceNumbers'
                            : 'SoluceNumbers Invalid'
                        }
                        >
                          {conformityRtplus
                            ? t('rtplus_conformity_res')
                            : t('rtplus_conformity_resp')}
                        </div>
                        <div
                          className={
                          conformityRtplus
                            ? 'underlinePanneau'
                            : 'underlinePanneau Invalid'
                        }
                        >
                          ______________________________
                        </div>
                      </Segment>
                      )
                  }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            {
              // #region Component Table
            }
            {this.renderComponentTable()}
            {
              // #endregion
            }

            <Segment basic id="totalRtPlus">
              <List floated="right" horizontal>
                <List.Item id="textTotalRtPlus">{t('rtplus_total')}</List.Item>
                <List.Item id="totalNumbersRtPlus">
                  {Math.ceil(
                    Number(rtPlusTotal || 0)
                  ).toLocaleString()}
                  {' '}
                  €
                </List.Item>
                <List.Item id="underscoreTotalRtPlus">
                  ____________________________
                </List.Item>
              </List>
            </Segment>
            <Segment basic id="nextButtonRtPlus">
              <Button
                id="btnSend"
                floated="right"
                color="blue"
                type="submit"
                role="button"
                onClick={() => this.screenPage()}
              >
                {t('download_pdf')}
                <Image src={Pdf} />
              </Button>
            </Segment>
          </Segment>
        </Container>

        <SemanticToastContainer />
      </div>
    );
  }
}

rtPlusSoluceComponent.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      env: PropTypes.string,
    }),
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({

    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  t: ProductType.func,
};

export default translate('rtPlusSoluceComponent')(rtPlusSoluceComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/rtplus/RtPlusSoluceComponent.jsx